import { Card, CardContent, Divider, Skeleton, Stack } from "@mui/material";
import FlexBox from "../../../../components/layouts/flexbox";

function InitiativeCardSkeleton() {
  return (
    <Card
      sx={{
        height: "100%",
        border: "1px solid #E5E7EB",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      }}
    >
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Stack gap={1.5}>
          <FlexBox alignItems="center" justifyContent="space-between" gap={1}>
            <FlexBox alignItems="center" gap={0.75}>
              <Skeleton variant="circular" animation="wave" width={18} height={18} />
              <Skeleton variant="text" animation="wave" width={56} height={18} />
            </FlexBox>
            <Skeleton
              variant="rounded"
              animation="wave"
              width={52}
              height={24}
              sx={{ borderRadius: 999 }}
            />
          </FlexBox>

          <Divider />

          <Skeleton variant="text" animation="wave" width="45%" height={18} />
          <Skeleton variant="text" animation="wave" width="90%" height={24} />
          <Skeleton variant="text" animation="wave" width="70%" height={20} />

          <FlexBox alignItems="center" gap={0.75}>
            <Skeleton variant="circular" animation="wave" width={16} height={16} />
            <Skeleton variant="text" animation="wave" width="75%" height={18} />
          </FlexBox>

          <Stack gap={0.5}>
            <Skeleton variant="text" animation="wave" width="100%" height={18} />
            <Skeleton variant="text" animation="wave" width="96%" height={18} />
            <Skeleton variant="text" animation="wave" width="88%" height={18} />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export { InitiativeCardSkeleton };
